import React, { useState } from 'react'
import ListItems from './ListItems'
import { useHistory } from 'react-router-dom'
import { processLink } from '../helpers'
import { Typography, Button } from 'foundations-library/components'
import { makeStyles } from '@material-ui/core'
import { useWidgetContext, WidgetSectionDataType } from 'providers'
import ShowInPopup from './ShowInPopup'
import List from './List'

const SMS_REGISTRATION_SECTION_SLUG = 'sms-registration'
const SMS_REGISTRATION_NO_FILTER_VALUE = 'all'

const jss = () => ({
    widget: {
        rowGap: '.5rem',
        maxWidth: ({ maxWidth }) => maxWidth || '100%',
        margin: 'auto',
        padding: '0 48px'
    },
    titleAndButtonContainer: {
        marginBottom: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
})

const useStyles = makeStyles(jss)

type FeaturesProps = {
    pageBasedData?: WidgetSectionDataType
}

/**
 *
 */
const Features = ({ pageBasedData: propPageBasedData }: FeaturesProps): JSX.Element => {
    const history = useHistory()
    const { pageBasedData: contextPageBasedData, selectedSection } = useWidgetContext()
    const pageBasedData = propPageBasedData || contextPageBasedData
    const styles = useStyles({ maxWidth: pageBasedData.maxWidth })
    const [openModal, setOpenModal] = useState(false)

    if (!pageBasedData.articles.length) return <></>
    const articlesTitle = pageBasedData.articlesTitle || pageBasedData.sectionName
    const goToArticle = (articleSlug) => {
        return processLink(`/support-center/${pageBasedData.slug}/${articleSlug}`, history)
    }

    const filterValue = pageBasedData.selectedArticleCategory || SMS_REGISTRATION_NO_FILTER_VALUE
    const getViewAllLink = () => {
        if (pageBasedData.slug !== SMS_REGISTRATION_SECTION_SLUG) {
            return `/support-center/${pageBasedData.slug}`
        }

        return `/support-center/${pageBasedData.slug}?filter=${filterValue}`
    }
    const content = (openInModal, slug) => <List isModal={openInModal} searchProp={selectedSection} sectionSlugProp={slug} />

    const renderPopup = (openInModal, slug) => openInModal && (
        <ShowInPopup
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            popupContent={content(openInModal, slug)}
        />
    )

    return <div className={`${styles.widget} bottom-widget`}>
        {(articlesTitle || pageBasedData.slug) && <div className={styles.titleAndButtonContainer} data-testid='widget-features'>
            {articlesTitle && <Typography variant='subtitle1' color='neutral-900' data-testid='widget-features-title'>{articlesTitle}</Typography>}
            {pageBasedData.slug && <Button
                color='primary'
                iconLeft={false}
                icon='go'
                variant='text'
                onClick={() => pageBasedData.isModal ? setOpenModal(true) : processLink(getViewAllLink(), history, true)}
                data-testid='widget-features-view-all-btn'
            >{pageBasedData.viewAllButtonText}</Button>}
        </div>}
        {renderPopup(openModal, pageBasedData.slug)}
        <ListItems sectionSlug={pageBasedData.slug} items={pageBasedData.articles.slice(0, 3)} isModal={pageBasedData.isModal} onRedirect={goToArticle} icon={pageBasedData.icon} />
    </div>
}

export default Features
